var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SplitViewGridTemplate',{ref:'intake-variety-size',attrs:{"screenConfig":_vm.leftGridConfig,"rightConfig":_vm.rightGridConfig,"backButtonRoute":'/settings/intake',"defaultUserSettings":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }